<template>
  <div class="app">
    <div
      v-if="firebaseNotif"
      class="min-vh-100 d-flex text-center h2 flex-column justify-content-center align-items-center w-100 nofit-box text-white position-fixed"
      style="z-index: 1040"
    >
      <c-modal
        v-model="showNotifMessage"
        no-close-on-esc
        no-close-on-backdrop
        centered
        ref="modal"
        :tag="false"
        size="lg"
        title="Notification Allowance Required"
      >
        <template>
          <div>
            Please allow MENUPOLY to send notifications to this web browser to get order updates in the dashboard with no delays.
          </div>
          <div>
            Go to browser privacy settings to allow notifications from www.menupoly.com
          </div>
        </template>
        <template #actions>
          <b-row class="flex-grow-1">
            <b-col cols="6">
              <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="closeWarn">
                Got it! Will do it later
              </b-btn>
            </b-col>

            <b-col cols="6" v-if="notificationStatus === 'default'">
              <b-btn variant="success" block class="text-nowrap" @click="requestNotifPerm">
                Enable Notification
              </b-btn>
            </b-col>
            <b-col cols="6" v-else>
              <b-btn variant="warning" block class="text-nowrap" @click="goTutorial">
                Show me how to do it
              </b-btn>
            </b-col>
          </b-row>
        </template>
      </c-modal>
    </div>
    <AppHeader fixed>
      <b-link class="navbar-brand px-1" @click="goToHome">
        <img
          class="navbar-brand-full d-none d-md-block"
          src="../../../public/img/logo-full.png"
          width="100%"
          alt="MENUPOLY"
        />
      </b-link>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <SidebarToggler class="d-md-down-none" display="lg" />

      <select class="restaurantSelectBox" @change="changeValue">
        <option
          :selected="+item.Value === +$store.state.selectedRestaurantId ? true : false"
          v-for="(item, index) in $store.state.restaurants"
          :key="index"
          :value="item.Value"
        >
          {{ item.Text }}
        </option>
      </select>
      <div v-if="isDeniedNotif" class="mx-1 d-none d-lg-block text-danger small font-weight-bold">
        Warning: Order updates are delayed. Allow MENUPOLY browser notifications.
        <b-link to="/tutorialVideoclips/index">
          Learn more...
        </b-link>
      </div>
      <b-navbar-nav :class="{'ml-auto mr-4': $dir.ltr, 'mr-auto  ml-4': $dir.rtl}">
        <Account :firstName="firstName" :picUrl="picUrl" :UserID="UserID" />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main :class="['main', 'position-relative', { 'py-3': !isCreateOrderRoute }]">
        <div :class="{'px-3': !isCreateOrderRoute}">
          <div v-if="isDeniedNotif" class="mx-1 d-block d-lg-none text-danger small font-weight-bold">
            Warning: Order updates are delayed. Allow MENUPOLY browser notifications.
            <b-link to="/tutorialVideoclips/index">
              Learn more...
            </b-link>
          </div>
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <span class="mx-1">&copy; {{ new Date().getYear() + 1900 }}</span>
      <div class="mx-2" :href="$config.websiteUrl">{{ $t('branding.copyRight') }}</div>
      <!--      <change-locale :class="{'ml-auto': $dir.ltr, 'mr-auto': $dir.rtl}" />-->
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import Account from './Account'
import pushNotification from './core/pushNotification/pushNotification'
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  // Aside as AppAside,
  // AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
  ChangeLocale
} from './core'

// import DefaultAside from './DefaultAside'
import * as types from '@/store/types'
import {mapState} from 'vuex'
import store from '../../store'
import CModal from '../shared/Cmodal'

export default {
  name: 'full',
  components: {
    CModal,
    Account,
    pushNotification,
    // AsideToggler,
    AppHeader,
    AppSidebar,
    // AppAside,
    TheFooter,
    Breadcrumb,
    ChangeLocale,
    // DefaultAside,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      nav: nav.items,
      restaurant: [],
      firstName: null,
      picUrl: null,
      UserID: null,
      notifStatus: '',
      notificationStatus:'',
      showNotifMessage: true,
    }
  },
  watch: {
    '$store.state.selectedRestaurantId': {
      handler: function(newVal) {
        if (newVal) {
          this.GetRestaurantMenuEditURL(newVal)
          this.GetRestaurantRestauranteurID(newVal)
        }
      },
      immediate: true
    },
    '$store.state.firebaseNotif': {
      handler: function(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$refs.modal.show()
          })
        } else {
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState(['firebaseNotif']),
    name() {
      return this.$route.name
    },
    isCreateOrderRoute() {
      return this.$route.path && this.$route.path.startsWith('/createOrder')
    },
    fullName() {
      // let wacc = JSON.parse(localStorage.getItem('wacc'))
      // let fullName = wacc.v.name
      return 'fullName'
    },
    breadcrumbItems() {
      return this.$route.matched
    },
    isDeniedNotif() {
      return localStorage.getItem('notifStatus') && localStorage.getItem('notifStatus') !== 'granted'
    }
  },
  mounted() {
    
    
   
    this.notificationStatus = Notification.permission;
    
    if (!localStorage.getItem('SET_ACCOUNT')) {
      this.$router.replace('/login')
    } else {
      this.$api.getRestaurant.GetCurrentUserInfo().then(res => {
        if (res.success) {
          this.firstName = res.results.FirstName
          localStorage.setItem('name', this.firstName ? this.firstName : '')
          localStorage.setItem('lastName', res.results.LastName)
          localStorage.setItem('Email', res.results.Email)
          this.picUrl = res.results.ProfilePhoto
          this.UserID = res.results.UserID
          this.$store.commit(types.CLIENT_TYPE_ID, res.results.ClientTypeID)
          localStorage.setItem('ClientTypeID', res.results.ClientTypeID)
          localStorage.setItem('RoleID', res.results.RoleID)
          let model = {
            RestaurantID:localStorage.getItem("selectedRestaurant")
          }
          this.$api.getRestaurant.GetRestaurantMenuboardPermission(model).then(res=>{
            localStorage.setItem("hasMenuboard", undefined)
            localStorage.setItem("hasMenuboard", res.results)
          })
          
        }
      })
    }
  },
  methods: {
    goToHome() {
      window.location.reload()
    },
    requestNotifPerm(){
    Notification.requestPermission().then(()=>{
      location.reload()
    })
  
    },
    closeWarn() {
      this.$store.commit(types.NOTIF_FIREBASE, false)
      this.$refs.modal.hide()
    },
    goTutorial() {
      this.$store.commit(types.NOTIF_FIREBASE, false)
      this.$refs.modal.hide()
      this.$router.push('/tutorialVideoclips/index')
    },
    changeValue(e) {
      
      this.$store.commit(types.CHANGERESTAURANT, e.target.value)
      let findRestaurant = this.$store.state.restaurants.find(item => item.Value === e.target.value)
      if (findRestaurant) {
        localStorage.setItem('selectedRestaurantName', findRestaurant.Text)
      }
      localStorage.setItem('selectedRestaurant', e.target.value)
      window.location.href = window.location.origin + '/todayOrders/index';
      // this.GetRestaurantMenuEditURL(e.target.value)
    },
    GetRestaurantMenuEditURL(RestaurantID) {
      //change menu edit url by change restarurant id
      //This link is in the following path
      //src/components/layout/core/sidebar/sidebar nav
      let data = {
        RestaurantID,
        // UserID: localStorage.getItem('userID')
      }
      this.$api.getRestaurant.GetRestaurantMenuEditURL(data).then(res => {
        if (res.success) {
          localStorage.setItem('staticLinkRestaurant', res.results)
          this.$store.commit(types.MENU_EDITOR, res.results)
        }
      })
    },
    GetRestaurantRestauranteurID(RestaurantID) {
      let data = {
        RestaurantID,
        // UserID: localStorage.getItem('userID')
      }
      this.$api.getRestaurant.GetRestaurantRestauranteurID(data).then(res => {
        if (res.success) {
          localStorage.setItem('restaurantProfile', res.results)
        }
      })
    },
    checkNotif() {
      if (navigator.permissions) {
        return navigator.permissions.query({name: 'notifications'}).then(res => {
          this.notifStatus = res.state
          if (res.state === 'granted') {
            this.$store.commit(types.NOTIF_FIREBASE, false)
          } else if (res.state === 'denied') {
            this.$store.commit(types.NOTIF_FIREBASE, true)
          } else {
            if (!('Notification' in window)) {
              this.$showError('Your browser does not use this feature')
            } else {
              Notification.requestPermission().then(function(permission) {
                if (permission === 'granted') {
                  this.$store.commit(types.NOTIF_FIREBASE, false)
                } else {
                  this.$store.commit(types.NOTIF_FIREBASE, true)
                }
              })
            }
          }
        })
      } else {
        this.$showError('Your browser does not use this feature')
      }
    }
  }
}
</script>
<style scoped>
.nofit-box {
  background: rgba(0, 0, 0, 0.8);
  top: 0 !important;
  left: 0 !important;
}

.restaurantSelectBox {
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #ececec;
  width: 30%;
}
@media screen and (min-width: 170px) and (max-width: 768px) {
  .restaurantSelectBox {
    width: 60%;
  }
}
/*.app-body{*/
/*  overflow-x: unset !important;*/
/*}*/
</style>
